import type { Node } from '../../core';
import type { InternalNode } from '../../store';

/** The node handed to v11 element callbacks: the app's node plus the engine's position and measured size. */
export const toEventNode = ({ node, positionAbsolute, width, height }: InternalNode): Node => ({
  ...node,
  positionAbsolute,
  width: width ?? node.width,
  height: height ?? node.height,
});
